import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import styles from './ModalOverlay.module.scss';

interface ModalOverlayProps {
  isOpen: boolean;
  onClose?: () => void;
  preventClose?: boolean;
  children: React.ReactNode;
  zIndex?: number;
}

const backdropVariants = {
  visible: { opacity: 1 },
  hidden: { opacity: 0 },
};

const ModalOverlay: React.FC<ModalOverlayProps> = ({
  isOpen,
  onClose,
  preventClose = false,
  children,
  zIndex = 3
}) => {
  // Bloquear scroll del body cuando el modal está abierto
  useEffect(() => {
    if (isOpen) {
      // Guardar posición actual del scroll
      const scrollY = window.scrollY;
      
      // Bloquear scroll
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      
      return () => {
        // Restaurar scroll
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        
        // Restaurar posición del scroll
        window.scrollTo(0, scrollY);
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (!preventClose && onClose) {
      onClose();
    }
  };

  return (
    <motion.div
      className={styles.overlay}
      style={{ zIndex }}
      variants={backdropVariants}
      initial="hidden"
      animate="visible"
      exit="hidden"
      onClick={handleOverlayClick}
    >
      <div className={styles.modalOverlay} onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </motion.div>
  );
};

export default ModalOverlay;

